// extracted by mini-css-extract-plugin
export default {"bot-builder":"styles_bot-builder__FAuhH","control-panel":"styles_control-panel__raRU6","options":"styles_options__pjaj9","option":"styles_option__caib7","show":"styles_show__ILPHv"};